import React, { useEffect, useMemo } from "react";
import { Tag, TagsInput } from "@cadmakers-ui/core";
import { CMDataGrid, DataGridFilterBy } from "cm-data-grid";
import { Link } from "react-router-dom";
import { TagDisplay, useTags } from "..";
import { appPaths } from "../../Common";

const TagList: React.FC = () => {
  const tags = useTags();

  const tableData = useMemo(() => {
    if (!tags.loadingState.isLoaded) {
      return [];
    }

    return tags.tags.map(t => {
      const link = appPaths.tags.details.replace(":tagId", t.id.toString());

      return [
        {
          displayValue: <TagDisplay selectedIds={[t.id]} />,
          value: t.name,
          key: 0
        },
        {
          displayValue: <Link to={link}>View Feedbacks</Link>,
          value: "",
          key: 0
        }
      ];
    });
  }, [tags]);

  return (
    <>
      {tags.loadingState.isLoaded && (
        <CMDataGrid
          exportXls
          exportPdf
          changeableView
          selectableRow={false}
          pageLength={100}
          paging
          resizeConfigs={{
            resizable: false,
            options: {
              liveDrag: true,
              disabledColumns: []
            },
            serialize: false
          }}
          columns={[
            {
              name: "Tag Name",
              searchable: true,
              sortable: true,
              filterable: { by: DataGridFilterBy.StartsWith }
            },
            {
              name: "Actions",
              searchable: false,
              sortable: false,
              filterable: false
            }
          ]}
          mobileConfig={{
            header: 1,
            description: 7,
            // image: 0,
            info: 2,
            icon: 3
          }}
          useTiles={false}
          data={tableData}
        />
      )}
    </>
  );
};

export default TagList;
